import axios from "axios";

export const FetchMatchDetails = async (matchId) => {
  const response = await axios.get(
    `${process.env.REACT_APP_FEED_BASE_URL}/feeds/${process.env.REACT_APP_LEAGUE_NAME}/match-details/${matchId}?token=${process.env.REACT_APP_FEED_TOKEN}`
  );

  return response.data;
};

export const FetchGolfTournamentPlayers = async (tournametId) => {
  const response = await axios.get(
    `${process.env.REACT_APP_FEED_BASE_URL}/golf/tournament/${tournametId}/players?token=${process.env.REACT_APP_FEED_TOKEN}`
  );

  return response.data;
};

export const FetchIihfMatchDetails = async (matchId) => {
  const response = await axios.get(
    `${process.env.REACT_APP_FEED_BASE_URL}/hockey/matches/${matchId}`
  );

  return response.data;
};

export const FetchFACupMatchDetails = async (matchId) => {
  const response = await axios.get(
    `${process.env.REACT_APP_FEED_BASE_URL}/football/matches/${matchId}`
  );

  return response.data;
};
